import type { TicketStatus } from '@one-deployment/shared'

/**
 * Each status drawn as Linear draws its states: dashed ring for Backlog, empty
 * ring for Todo, a ring filling up through the started ones, a filled mark for
 * the finished ones. Needs attention is ours, not Linear's: a plain red dot.
 */
const STARTED: Partial<Record<TicketStatus, [string, number]>> = {
  in_progress: ['#f2c94c', 0.25], needs_merge: ['#4cb782', 0.35], blocked: ['#eb5757', 0.5], client_response: ['#4cb782', 0.6],
  out_of_scope: ['#26b5ce', 0.65], ready_to_test: ['#eb5757', 0.75],
}

export function StatusIcon({ s, size = 14 }: { s: TicketStatus | string; size?: number }) {
  const box = { width: size, height: size, viewBox: '0 0 14 14', 'aria-hidden': true, className: 'shrink-0' } as const
  if (s === 'needs_attention') return <svg {...box}><circle cx="7" cy="7" r="5" fill="#eb5757" /></svg>
  if (s === 'backlog') return <svg {...box}><circle cx="7" cy="7" r="6" fill="none" stroke="#95a2b3" strokeWidth="1.5" strokeDasharray="1.4 1.74" /></svg>
  if (s === 'todo') return <svg {...box}><circle cx="7" cy="7" r="6" fill="none" stroke="#e2e2e2" strokeWidth="1.5" /></svg>
  if (s === 'done' || s === 'released') {
    return <svg {...box}><circle cx="7" cy="7" r="7" fill={s === 'done' ? '#5e6ad2' : '#4cb782'} /><path d="M4.2 7.2l1.9 1.9 3.7-4" fill="none" stroke="#000" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
  }
  if (s === 'duplicate') return <svg {...box}><circle cx="7" cy="7" r="7" fill="#95a2b3" /><path d="M4.8 9.2l4.4-4.4" stroke="#000" strokeWidth="1.8" strokeLinecap="round" /></svg>
  if (s === 'triage') {
    return <svg {...box}><circle cx="7" cy="7" r="7" fill="#fc7840" /><path d="M3.5 7h7M5.3 5.2L3.5 7l1.8 1.8M8.7 5.2L10.5 7 8.7 8.8" fill="none" stroke="#000" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
  }
  const [color, part] = STARTED[s as TicketStatus] ?? ['#95a2b3', 0.5]
  const r = 1.75, len = 2 * Math.PI * r
  return (
    <svg {...box}>
      <circle cx="7" cy="7" r="6" fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx="7" cy="7" r={r} fill="none" stroke={color} strokeWidth={2 * r} strokeDasharray={`${part * len} ${len}`} transform="rotate(-90 7 7)" />
    </svg>
  )
}
